import { state } from './state.js';

// ================================================================
// TAB SWITCHING
// ================================================================
export function setupTabSwitching(onTimelineActivate) {
  document.querySelectorAll(".tab-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const tab = btn.dataset.tab;
      state.ui.activeTab = tab;
      document.querySelectorAll(".tab-btn").forEach(b => b.classList.toggle("active", b.dataset.tab === tab));
      document.querySelectorAll(".tab-content").forEach(c => c.classList.toggle("active", c.dataset.tab === tab));
      if (tab === "timeline" && onTimelineActivate) {
        onTimelineActivate();
      }
    });
  });
}

// ================================================================
// TOAST
// ================================================================
export function showToast(msg) {
  const el = document.getElementById("toast");
  el.textContent = msg;
  el.classList.add("show");
  setTimeout(() => el.classList.remove("show"), 2000);
}

// ================================================================
// MODAL HELPERS
// ================================================================
export function closeModal() {
  document.getElementById("modal-overlay").classList.remove("open");
}

export function showConfirmModal(message, onConfirm) {
  const modal = document.getElementById("modal");
  modal.innerHTML = `
    <h3>Confirm</h3>
    <p style="font-size:12px;color:var(--text);margin-bottom:12px;">${message}</p>
    <div class="modal-actions">
      <button class="btn-cancel" id="confirm-cancel">Cancel</button>
      <button class="btn-primary" id="confirm-ok" style="background:var(--danger);border-color:var(--danger);">Delete</button>
    </div>
  `;
  document.getElementById("modal-overlay").classList.add("open");
  document.getElementById("confirm-cancel").addEventListener("click", closeModal);
  document.getElementById("confirm-ok").addEventListener("click", () => { closeModal(); onConfirm(); });
}

export function showConfirmDialog({ title = "Confirm", message, okLabel = "OK", cancelLabel = "Cancel", danger = false, onConfirm, onCancel }) {
  const modal = document.getElementById("modal");
  modal.innerHTML = `
    <h3>${title}</h3>
    <p style="font-size:12px;color:var(--text);margin-bottom:12px;">${message}</p>
    <div class="modal-actions">
      <button class="btn-cancel" id="cdlg-cancel">${cancelLabel}</button>
      <button class="btn-primary" id="cdlg-ok"${danger ? ' style="background:var(--danger);border-color:var(--danger);"' : ""}>${okLabel}</button>
    </div>
  `;
  document.getElementById("modal-overlay").classList.add("open");
  let resolved = false;
  const finish = (cb) => { if (resolved) return; resolved = true; closeModal(); if (cb) cb(); };
  document.getElementById("cdlg-cancel").addEventListener("click", () => finish(onCancel));
  document.getElementById("cdlg-ok").addEventListener("click", () => finish(onConfirm));
}

export function showPromptModal(title, defaultValue, onConfirm) {
  const modal = document.getElementById("modal");
  modal.innerHTML = `
    <h3>${title}</h3>
    <input type="text" id="prompt-input" value="${defaultValue.replace(/"/g, '&quot;')}"
      style="width:100%;background:var(--bg);border:1px solid var(--border);color:var(--text-bright);
             font-family:var(--font-mono);font-size:12px;padding:6px 8px;border-radius:4px;margin-bottom:4px;">
    <div class="modal-actions">
      <button class="btn-cancel" id="prompt-cancel">Cancel</button>
      <button class="btn-primary" id="prompt-ok">OK</button>
    </div>
  `;
  document.getElementById("modal-overlay").classList.add("open");
  const input = document.getElementById("prompt-input");
  input.select();
  document.getElementById("prompt-cancel").addEventListener("click", closeModal);
  document.getElementById("prompt-ok").addEventListener("click", () => {
    const val = input.value;
    closeModal();
    onConfirm(val);
  });
  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") { const val = input.value; closeModal(); onConfirm(val); }
  });
}
